import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import i18n from 'i18n-js';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Box, IconButton, Paper, Tab, Tabs } from '@material-ui/core';

import Finances from './components/finances';
import { theme } from 'config/theme';
import Tips from './components/tips';
import Storno from './components/storno';
import PaymentsTab from './components/payments';

interface FinanceProps {
    restaurantId?: string;
    isOld?: boolean;
    style?: React.CSSProperties;
}

enum FinanceView {
    SALES,
    PAYMENTS,
    TIPS,
    STORNO,
}

export default function Finance(props: FinanceProps) {
    const history = useHistory();
    const [view, setView] = useState<FinanceView>(FinanceView.SALES);

    return (
        <Paper style={{ overflow: 'hidden', paddingTop: 50, ...props.style }}>
            <Box
                display={'flex'}
                justifyContent={'flex-start'}
                style={{
                    borderBottom: `1px solid ${theme.palette.grey['300']}`,
                    padding: '0px 15px',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 99
                }}
            >
                <IconButton
                    aria-label="delete"
                    size="small"
                    style={{ color: theme.palette.common.black }}
                    //className={classes.iconButton}
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon fontSize="inherit" />
                </IconButton>
                <Tabs
                    id="hide-in-print"
                    value={view}
                    onChange={(_, newValue) => setView(newValue)}
                    variant="scrollable"
                    aria-label="wrapped label tabs example"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label={i18n.t('navigationTabs.sales')} value={FinanceView.SALES} />
                    <Tab label={i18n.t('navigationTabs.payments')} value={FinanceView.PAYMENTS} />
                    <Tab label={i18n.t('navigationTabs.tips')} value={FinanceView.TIPS} />
                    <Tab label={i18n.t('navigationTabs.storno')} value={FinanceView.STORNO} />
                </Tabs>
            </Box>
            {view === FinanceView.SALES && <Finances {...props} />}
            {view === FinanceView.PAYMENTS && <PaymentsTab {...props } />}
            {view === FinanceView.TIPS && <Tips />}
            {view === FinanceView.STORNO && <Storno />}
        </Paper>
    );
}
